import { TextSizes } from "@smartsuite/react-ui/lib";
import styled, { createGlobalStyle } from "styled-components";
import {
  Colors,
  GrayColors,
  SolutionColorVariables,
  TextColorNames,
} from "@smartsuite/types";

/** Dropdown list is portaled outside the field; scope disabled-option overrides here. */
export const AUTOMATION_SELECT_EDITOR_DROPDOWN_CLASS =
  "automation-select-editor-dropdown";

const DROPDOWN_BORDER_RADIUS = "5px";

export const AutomationSelectEditorDropdownStyles = createGlobalStyle`
  /* Match bottom corners to top when connection dropdown has a footer. */
  .dropdown-panel:has(.select-list-items.${AUTOMATION_SELECT_EDITOR_DROPDOWN_CLASS}):has(
      .single-select__footer
    ) {
    border-bottom-left-radius: ${DROPDOWN_BORDER_RADIUS} !important;
    border-bottom-right-radius: ${DROPDOWN_BORDER_RADIUS} !important;
    overflow: hidden;

    &::before {
      border-bottom-left-radius: ${DROPDOWN_BORDER_RADIUS} !important;
      border-bottom-right-radius: ${DROPDOWN_BORDER_RADIUS} !important;
    }
  }

  /* Grouped lists omit disabledOptions in react-ui; mark rows via data-unavailable. */
  .select-list-items.${AUTOMATION_SELECT_EDITOR_DROPDOWN_CLASS} li.option:has([data-unavailable="true"]),
  .select-list-items.${AUTOMATION_SELECT_EDITOR_DROPDOWN_CLASS} li.option.is-disabled {
    cursor: not-allowed !important;

    &,
    & * {
      cursor: not-allowed !important;
    }

    &:hover,
    &.is-focused {
      background-color: transparent !important;
      color: ${GrayColors["G-4"]} !important;
    }

    .option__content {
      width: 100%;
    }
  }
`;

export const Option = styled.div<{ $unavailable?: boolean }>`
  font-size: 15px;
  display: block;
  width: 100%;
  margin: 7px;
  box-sizing: border-box;

  ${({ $unavailable }) =>
    $unavailable
      ? `
    cursor: not-allowed !important;

    &,
    & * {
      cursor: not-allowed !important;
    }
  `
      : ""}

  svg,
  span {
    display: inline-block;
    justify-content: center;
    align-items: center;
  }

  svg {
    margin-right: 10px;
  }

  .details-text {
    margin-top: 2px;
  }
  .description-text {
    margin-top: 4px;
  }
`;

export const SelectedOption = styled(Option)<{ $unavailable?: boolean }>`
  margin-left: 0px;
  margin-top: 8px;

  ${({ $unavailable }) =>
    $unavailable
      ? `
    color: ${GrayColors["G-4"]} !important;

    &,
    & * {
      cursor: pointer !important;
    }

    * {
      color: ${GrayColors["G-4"]} !important;
    }
  `
      : ""}
`;

export const StyledReactSelectFieldContainer = styled.div<{
  width?: number;
  $hasError?: boolean;
}>`
  margin-bottom: 22px;
  margin-right: 0px;

  .react-input-group {
    min-height: 37px;
  }

  .react-input-group.is-error {
    border-color: ${Colors.bRed} !important;
  }

  ${({ $hasError }) =>
    $hasError
      ? `
    .react-input-group {
      border-color: ${Colors.bRed} !important;
    }
  `
      : ""}

  position: relative;
  z-index: 10;
  &.hide-label .caption-block-title {
    color: transparent;
  }

  .container-is-refreshing {
    background: #fafafa;
    pointer-events: none;

    .select-placeholder__arrow-icon {
      color: #b2b2b3;
    }
  }

  ${({ width }) =>
    width === undefined ? "" : `width: ` + String(width) + `%`};
`;

export const stylesSwitchButtonRect = {
  height: 27,
  heightSlider: 27,
  widthSlider: 40,
  widthItem: 44,
  background: GrayColors["G-1"],
  backgroundHover: GrayColors["G-1-5"],
  borderRadius: 5,
  color: "#6B6B6B",
  colorHover: "#6B6B6B",
  colorActive: GrayColors["G-0"],
  colorActiveHover: GrayColors["G-0"],
  backgroundSlider: SolutionColorVariables.sc1,
  textSize: TextSizes.XS,
  fontFamily: "inherit",
  fontWeight: 400,
};

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
`;

export const OptionMain = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-width: 0;
`;

export const UnavailableBadge = styled.span`
  flex-shrink: 0;
  align-self: center;
  padding: 3px 9px;
  border-radius: 4px;
  background-color: ${GrayColors["G-1"]};
  color: ${TextColorNames.tertiary};
  font-size: 11px;
  font-weight: 200;
  line-height: 16px;
  white-space: nowrap;
  margin-right: 20px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;

  .support-icon {
    margin-right: 3px;
    fill: #9b9c9e;
  }

  .support-icon:hover {
    margin-right: 3px;
    fill: #4d4d4d;
  }
`;
